<template>
  <div>
    <template v-if="mention">
      <template v-for="{ type, value } in structuredText">
        <span v-if="type === 'text'" :key="type + value">{{ value }}</span>
        <span
          v-else
          :id="`tag-${value}}`"
          :key="type + value"
          class="bg-light-blue"
        >
          <b-tooltip :target="`tag-${value}}`" placement="bottom">
            {{ mention.user.name }} {{ mention.user.surname }} </b-tooltip
          >{{ value }}</span
        >
      </template>
    </template>
    <template v-else>{{ text }}</template>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "MentionText",
  props: {
    mention: {
      type: Object,
      default: null,
    },
    text: {
      type: String,
      required: true,
    },
    entryKey: {
      type: String,
      required: true,
    },
  },
  computed: {
    structuredText() {
      const output = [];
      if (this.mention) {
        const entries = this.mention.entries[this.entryKey];
        let idx = 0;
        for (const entry of entries) {
          if (idx < entry.start) {
            output.push({
              type: "text",
              value: this.text.substring(idx, entry.start),
            });
          }
          output.push({
            type: "tag",
            value: this.text.substring(entry.start, entry.end),
          });
          idx = entry.end;
        }
        if (idx < this.text.length) {
          output.push({
            type: "text",
            value: this.text.substring(idx),
          });
        }
      }
      return output;
    },
  },
});
</script>

<style scoped></style>
